<template>
  <CustomModal
    :is-modal-open="isOpen"
    @toggleModal="closeDelete"
    @onClickAway="closeDelete"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-dvw tw:md:w-auto tw:max-w-[100vw] tw:md:max-w-none tw:rounded-md'"
  >
    <template #modalHeader>
      <p class="tw:text-xl tw:text-gray-700">{{ $t('app_images_actions_delete') }}</p>
    </template>

    <div class="tw:mt-2 tw:flex tw:py-11">
      {{ $t('app_hotel_details_delete_confirmation') }}
    </div>

    <template #modalFooter>
      <div class="tw:w-full tw:flex tw:flex-col tw:md:flex-row tw:justify-center tw:gap-4">
        <GhostButton size="medium" class="tw:px-4" @click="closeDelete">{{
          $t('app_hotel_details_cancel_delete_language')
        }}</GhostButton>
        <DangerButton size="medium" class="tw:px-4" @click="emit('deleteLanguage', languageCode)">
          <span v-if="!isDeleting">{{ $t('app_hotel_details_delete_language') }}</span>
          <span v-if="isDeleting">
            <SmallDotLoader color="#fff" />
          </span>
        </DangerButton>
      </div>
    </template>
  </CustomModal>
</template>
<script setup>
import CustomModal from '@/components/base/CustomModal.vue'
import DangerButton from '@/components/base/buttons/DangerButton.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'

defineProps({
  languageCode: String,
  language: String,
  isOpen: Boolean,
  isDeleting: Boolean,
})

const emit = defineEmits(['deleteLanguage', 'closeDelete'])
const closeDelete = () => emit('closeDelete')
</script>
